import { useEffect, useState } from "react";
import { checkStaffAccess } from "../apis/checkStaffAccess";
import { getInsightDetails } from "../apis/getInsightDetails";
import AdminHeaderES from "../components/desktop/DE/AdminSetting/AdminHeader/AdminHeaderES";

type Props = {};

function AdminSettingES(Props: Props) {
  const [staff, setStaff] = useState<boolean | null>(null);
  const [insightDetails, setInsightDetails] = useState();

  useEffect(() => {
    checkStaffAccess()
      .then((isStaff) => {
        setStaff(isStaff);
      })
      .catch(() => {
        setStaff(false);
      });

    getInsightDetails()
      .then((insightResponse) => {
        setInsightDetails(insightResponse?.document_insights);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return <AdminHeaderES staff={staff} insightDetails={insightDetails} />;
}

export default AdminSettingES;
